import { Component, OnInit, Input } from '@angular/core';
import { SidebarItemModel } from '../../models/sidebar-item.model';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent implements OnInit {

  @Input() item: SidebarItemModel;

  constructor() { }

  ngOnInit() {
  }

}
